import * as colors from '@radix-ui/colors';
import type { ColorPalette, ColorScale, ColorTheme } from './types';

export const ACCENT_COLOR = 'orange';
export const ERROR_COLOR = 'red';
export const INFO_COLOR = 'blue';
export const SUCCESS_COLOR = 'green';
export const WARNING_COLOR = 'yellow';
export const GRAY_COLOR = 'slate';

function removeLettersFromObjectKeys(obj: Record<string, string>): ColorScale {
  const newObj: ColorScale = {};
  for (const key in obj) {
    const match = /\d+/.exec(key); // Find the number in the key
    if (match) {
      newObj[match[0]] = obj[key]; // Use the number as the new key
    }
  }
  return newObj;
}

function setSemanticAndNeutralColors(palette: ColorPalette): ColorTheme {
  return {
    color: {
      ...palette,
      accent: palette[ACCENT_COLOR],
      accentAlpha: palette[`${ACCENT_COLOR}Alpha`],
      error: palette[ERROR_COLOR],
      errorAlpha: palette[`${ERROR_COLOR}Alpha`],
      info: palette[INFO_COLOR],
      infoAlpha: palette[`${INFO_COLOR}Alpha`],
      success: palette[SUCCESS_COLOR],
      successAlpha: palette[`${SUCCESS_COLOR}Alpha`],
      warning: palette[WARNING_COLOR],
      warningAlpha: palette[`${WARNING_COLOR}Alpha`],
      neutral: palette[GRAY_COLOR],
      neutralAlpha: palette[`${GRAY_COLOR}Alpha`],
    },
  };
}

const light: ColorPalette = {
  red: removeLettersFromObjectKeys(colors.red),
  redAlpha: removeLettersFromObjectKeys(colors.redA),
  blue: removeLettersFromObjectKeys(colors.blue),
  blueAlpha: removeLettersFromObjectKeys(colors.blueA),
  green: removeLettersFromObjectKeys(colors.green),
  greenAlpha: removeLettersFromObjectKeys(colors.greenA),
  yellow: removeLettersFromObjectKeys(colors.yellow),
  yellowAlpha: removeLettersFromObjectKeys(colors.yellowA),
  orange: removeLettersFromObjectKeys(colors.orange),
  orangeAlpha: removeLettersFromObjectKeys(colors.orangeA),
  slate: removeLettersFromObjectKeys(colors.slate),
  slateAlpha: removeLettersFromObjectKeys(colors.slateA),
};

const dark: ColorPalette = {
  red: removeLettersFromObjectKeys(colors.redDark),
  redAlpha: removeLettersFromObjectKeys(colors.redDarkA),
  blue: removeLettersFromObjectKeys(colors.blueDark),
  blueAlpha: removeLettersFromObjectKeys(colors.blueDarkA),
  green: removeLettersFromObjectKeys(colors.greenDark),
  greenAlpha: removeLettersFromObjectKeys(colors.greenDarkA),
  yellow: removeLettersFromObjectKeys(colors.yellowDark),
  yellowAlpha: removeLettersFromObjectKeys(colors.yellowDarkA),
  orange: removeLettersFromObjectKeys(colors.orangeDark),
  orangeAlpha: removeLettersFromObjectKeys(colors.orangeDarkA),
  slate: removeLettersFromObjectKeys(colors.slateDark),
  slateAlpha: removeLettersFromObjectKeys(colors.slateDarkA),
};

export default {
  light: setSemanticAndNeutralColors(light),
  dark: setSemanticAndNeutralColors(dark),
};
